/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { NzSubmenuService } from "ng-zorro-antd/menu";
import { UiIsMenuInsideDropDownToken } from "../utils/menu.utils";
import { UiMenuService } from "./menu.service";

@Injectable()
export class UiSubmenuService extends NzSubmenuService {
  public constructor(
    @SkipSelf() @Optional() uiHostSubmenuService: UiSubmenuService,
    public uiMenuService: UiMenuService,
    @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean
  ) {
    super(uiHostSubmenuService, uiMenuService, isMenuInsideDropDown);
  }
}
